/**
 * @author HungNS
 */
import * as TYPE from "./type";
import axios from "axios";
import Config from "@/services/Config";

const domain = Config.getDomain();

const axiosInstance = axios.create({
    baseURL: domain,
});

const moduleHeader = {
    namespaced: true,
    state: () => ({
        headerInfo: null,
        displayOffCanvasBtn: true,
        activeTabId: TYPE.MENU_HOME,
        isHeaderInfoInit: false,
        isAuthenticated: false,
    }),
    mutations: {
        [TYPE.SET_HEADER_INFO](state, payload) {
            state.headerInfo = payload;
            state.isHeaderInfoInit = true;
        },
        setDisplayOffCanvasBtn(state, isDisplay) {
            state.displayOffCanvasBtn = isDisplay;
        },
        setActiveTabId(state, tabId) {
            state.activeTabId = tabId;
        },
        setIsAuthenticated(state, isAuthenticated) {
            state.isAuthenticated = isAuthenticated;
        },
    },
    actions: {
        async [TYPE.GET_HEADER_INFO]({commit}) {
            const response = await axiosInstance.get("/rest/initHeader");
            commit(TYPE.SET_HEADER_INFO, response.data);
        },
        [TYPE.SET_DISPLAY_OFF_CANVAS_BTN]({commit}, isDisplay) {
            commit('setDisplayOffCanvasBtn', isDisplay);
        },
        [TYPE.SET_ACTIVE_TAB_ID]({commit}, tabId) {
            commit('setActiveTabId', tabId);
        },
        [TYPE.SET_IS_AUTHENTICATED]({commit}, isAuthenticated) {
            commit('setIsAuthenticated', isAuthenticated);
        },
    },
    getters: {
        linksAppList({headerInfo}) {
            let linksAppList = {};
            if (headerInfo) {
                linksAppList = {
                    FX_APPSTORE_URL: headerInfo.fxAppStoreUrl,

                    FX_UNIVERSAL_LINK_URL: headerInfo.fxUniversalLinkUrl,

                    FX_DEEP_LINK_URL: headerInfo.fxDeepLinkUrl,

                    FX_OPENAPP_ANDROID_URL: headerInfo.fxOpenappAndroidUrl,

                    FX_GOOGLE_PLAY_URL: headerInfo.fxGooglePlayUrl,

                    GOOGLE_AUTH_ANDROID: headerInfo.googleAuthAndroidApp,
                    GOOGLE_AUTH_IOS: headerInfo.googleAuthIosApp,

                    WEBVIEW_GOOGLE_AUTHEN_APP_IOS_URL: headerInfo.webviewGoogleAuthIosApp,
                    WEBVIEW_GOOGLE_AUTHEN_APP_ANDROID_URL: headerInfo.webviewGoogleAuthAndroidApp,

                    CORPORATION_TYPE: headerInfo.corporationType,
                    FILE_UPLOAD_EXT: headerInfo.fileUploadExt,
                };
            }
            return linksAppList;
        },

        isHomeTabActive({activeTabId}) {
            return activeTabId === TYPE.MENU_HOME;
        },

    },
};
export default moduleHeader;
